import { styled } from "styled-components";

export const MyProfileEditWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  width: 600px;
  border: 1px solid #383838;
  border-radius: 30px;
  padding: 24px;
`;
